module.exports = __webpack_public_path__ + "img/validation-icon.efc3e36c.svg";